export const properties = [
  { 
    id: 1, 
    title: "The Glass Penthouse", 
    price: 4500000, 
    address: "101 Skyline Ave, Downtown",
    beds: 4, 
    baths: 4.5, 
    sqft: 4200, 
    type: "Penthouse",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80",
    lat: 40.7128, 
    lng: -74.0060,
    features: ["Panoramic Views", "Private Elevator", "Rooftop Pool"],
    agent: { name: "Sarah Miller", phone: "+1 (555) 012-3456" }
  },
  { 
    id: 2, 
    title: "Modernist Cliff Villa", 
    price: 8200000, 
    address: "88 Ocean Drive, Malibu",
    beds: 6, 
    baths: 7, 
    sqft: 8500, 
    type: "Villa",
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&q=80",
    lat: 40.7148, 
    lng: -74.0040,
    features: ["Infinity Pool", "Home Thetaer", "Wine Cellar"],
    agent: { name: "James Bond", phone: "+1 (555) 007-0070" }
  },
  { 
    id: 3, 
    title: "Historic Brownstone", 
    price: 3100000, 
    address: "45 Park Slope, Brooklyn",
    beds: 5, 
    baths: 3, 
    sqft: 3800, 
    type: "Townhouse",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&q=80",
    lat: 40.7118, 
    lng: -74.0080,
    features: ["Original Woodwork", "Garden", "Chef's Kitchen"],
    agent: { name: "Emily Blunt", phone: "+1 (555) 987-6543" }
  },
  { 
    id: 4, 
    title: "Eco-Friendly Loft", 
    price: 1200000, 
    address: "24 Green St, SOHO",
    beds: 2, 
    baths: 2, 
    sqft: 1800, 
    type: "Loft",
    image: "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&q=80",
    lat: 40.7138, 
    lng: -74.0020,
    features: ["Solar Panels", "Smart Home", "Vertical Garden"],
    agent: { name: "Elon Musk", phone: "+1 (555) 420-6969" }
  },
  { 
    id: 5, 
    title: "Seaside Mansion", 
    price: 12500000, 
    address: "1 Coastal Hwy, Hamptons",
    beds: 8, 
    baths: 10, 
    sqft: 12000, 
    type: "Mansion",
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?auto=format&fit=crop&q=80",
    lat: 40.7158, 
    lng: -74.0010,
    features: ["Private Beach", "Tennis Court", "Guest House"],
    agent: { name: "Oprah W.", phone: "+1 (555) 111-2222" }
  },
  { 
    id: 6, 
    title: "Minimalist Studio", 
    price: 550000, 
    address: "12 Art District, Chelsea",
    beds: 1, 
    baths: 1, 
    sqft: 800, 
    type: "Studio",
    image: "https://images.unsplash.com/photo-1554995207-c18c203602cb?auto=format&fit=crop&q=80",
    lat: 40.7108, 
    lng: -74.0090,
    features: ["High Ceilings", "Doorman", "Gym"],
    agent: { name: "Andy Warhol", phone: "+1 (555) 333-4444" }
  }
];
